const config = {
  logLevel: Number(process.env.LOGLEVEL ?? '5', 10),
  chronosApiUrl: process.env.CHRONOS_API_URL,
  chronosSocketUrl: process.env.CHRONOS_SOCKET_URL,
};

export default config;
